//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





import UMUM from "../../library/umum";
import DATA_MASTER from "../../library/dataMaster";


export default {
  props: ["biodata_id", "nip"],
  data() {
    
    return {
      list_riwayat: [],
      cpns_pns :[],

      cpns : {
     
        cpns_id: '',
        pns_orang_id : '',
        biodata_id: this.biodata_id,

        kartu_pegawai: '',
        status_cpns_pns : '',
        nama_jabatan_angkat_cpns : '',
        nomor_dokter_pns : '',
        tanggal_dokter_pns : '',
        nomor_sk_cpns : '',
        tgl_sk_cpns : '',
        nomor_sk_pns : '',
        tgl_sk_pns : '',
        nomor_sttpl : '',
        tgl_sttpl : '',
        pertek_cpns_pns_l2th_nomor : '',
        pertek_cpns_pns_l2th_tanggal : '',
        nomor_spmt : '',
        tmt_pns : '',
     

        created_at : '',
        updated_at : '',

        status : 1,
        file : null,
        userId : '',
        createdAt : '',
      },

      mdl_detil_riwayat: false,
      mdl_detil_riwayat_add: false,
      mdl_detil_riwayat_add_lampiran: false,
      mdl_detil_riwayat_edit: false,
      mdl_detil_riwayat_hapus: false,
      file_old :'',

      UMUM: UMUM,
      DATA_MASTER: DATA_MASTER,

      btn_add: false,

      tab: 'disetujui',


      loadRiwayatSIA : true,
      fileLoadSIA :true,
      fileLoadEmpty : false,
      fileRiwayat : null,
      kodeDok : '889',


      status :1,



    };
  },

  methods: {
    getRiwayat: function(){

      this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_cpns+'view', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              biodata_id : this.cpns.biodata_id,
              status : this.status
            })
        }).then((res) => res.json()).then((res_data) => {
          this.cpns_pns = res_data;
          // console.log(this.cpns_pns);

      
          


          this.loadRiwayatSIA = false;
          // console.log(res_data);
        })
    },

    addData : function() {

      var formData = new FormData();
      formData.append('cpns_id', this.cpns.cpns_id);
      formData.append('pns_orang_id', this.cpns.pns_orang_id);
      formData.append('kartu_pegawai', this.cpns.kartu_pegawai);
      formData.append('status_cpns_pns', this.cpns.status_cpns_pns);
      formData.append('nama_jabatan_angkat_cpns', this.cpns.nama_jabatan_angkat_cpns);
      formData.append('nomor_dokter_pns', this.cpns.nomor_dokter_pns);
      formData.append('tanggal_dokter_pns', this.cpns.tanggal_dokter_pns);
      formData.append('nomor_sk_cpns', this.cpns.nomor_sk_cpns);
      formData.append('tgl_sk_cpns', this.cpns.tgl_sk_cpns);
      formData.append('nomor_sk_pns', this.cpns.nomor_sk_pns);
      formData.append('tgl_sk_pns', this.cpns.tgl_sk_pns);
      formData.append('nomor_sttpl', this.cpns.nomor_sttpl);
      formData.append('tgl_sttpl', this.cpns.tgl_sttpl);
      formData.append('pertek_cpns_pns_l2th_nomor', this.cpns.pertek_cpns_pns_l2th_nomor);
      formData.append('pertek_cpns_pns_l2th_tanggal', this.cpns.pertek_cpns_pns_l2th_tanggal);
      formData.append('nomor_spmt', this.cpns.nomor_spmt);
      formData.append('tmt_pns', this.cpns.tmt_pns);
      
      
      formData.append('biodata_id', this.cpns.biodata_id);
      formData.append('nip', this.nip);
      formData.append('kode', this.kodeDok);



      formData.append('file', this.cpns.file);

      fetch(this.$store.state.url.URL_simpeg_cpns+'createData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then(res => res.json()).then(() => {
          this.getRiwayat();
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
      });
     
    },


    editData : function(){

      var formData = new FormData();
      
      formData.append('cpns_id', this.cpns.cpns_id);
      formData.append('pns_orang_id', this.cpns.pns_orang_id);
      formData.append('kartu_pegawai', this.cpns.kartu_pegawai);
      formData.append('status_cpns_pns', this.cpns.status_cpns_pns);
      formData.append('nama_jabatan_angkat_cpns', this.cpns.nama_jabatan_angkat_cpns);
      formData.append('nomor_dokter_pns', this.cpns.nomor_dokter_pns);
      formData.append('tanggal_dokter_pns', this.cpns.tanggal_dokter_pns);
      formData.append('nomor_sk_cpns', this.cpns.nomor_sk_cpns);
      formData.append('tgl_sk_cpns', this.cpns.tgl_sk_cpns);
      formData.append('nomor_sk_pns', this.cpns.nomor_sk_pns);
      formData.append('tgl_sk_pns', this.cpns.tgl_sk_pns);
      formData.append('nomor_sttpl', this.cpns.nomor_sttpl);
      formData.append('tgl_sttpl', this.cpns.tgl_sttpl);
      formData.append('pertek_cpns_pns_l2th_nomor', this.cpns.pertek_cpns_pns_l2th_nomor);
      formData.append('pertek_cpns_pns_l2th_tanggal', this.cpns.pertek_cpns_pns_l2th_tanggal);
      formData.append('nomor_spmt', this.cpns.nomor_spmt);
      formData.append('tmt_pns', this.cpns.tmt_pns);
      


      formData.append('biodata_id', this.cpns.biodata_id);
      formData.append('nip', this.nip);
      formData.append('kode', this.kodeDok);

      formData.append('file', this.cpns.file);
      formData.append('file_old', this.file_old);

      fetch(this.$store.state.url.URL_simpeg_cpns+'updateData', {
          method: "POST",
          headers: {
              authorization : 'kikensbatara '+localStorage.token
          },
          body: formData
      }).then((res_data) => {
          this.getRiwayat();
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_simpeg_cpns + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.cpns.cpns_id, file : this.file_old})
      }).then(res_data => {
          this.getRiwayat();
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
      });

    },

    selectRiwayat: function(data){

          this.cpns.cpns_id = data.cpns_id;
          this.cpns.pns_orang_id = data.pns_orang_id;
          this.cpns.biodata_id = data.biodata_id;

          this.cpns.kartu_pegawai = data.kartu_pegawai;
          this.cpns.status_cpns_pns = data.status_cpns_pns;
          this.cpns.nama_jabatan_angkat_cpns = data.nama_jabatan_angkat_cpns;
          this.cpns.nomor_dokter_pns = data.nomor_dokter_pns;
          this.cpns.tanggal_dokter_pns = data.tanggal_dokter_pns;
          this.cpns.nomor_sk_cpns = data.nomor_sk_cpns;
          this.cpns.tgl_sk_cpns = data.tgl_sk_cpns;
          this.cpns.nomor_sk_pns = data.nomor_sk_pns;
          this.cpns.tgl_sk_pns = data.tgl_sk_pns;
          this.cpns.nomor_sttpl = data.nomor_sttpl;
          this.cpns.tgl_sttpl = data.tgl_sttpl;
          this.cpns.pertek_cpns_pns_l2th_nomor = data.pertek_cpns_pns_l2th_nomor;
          this.cpns.pertek_cpns_pns_l2th_tanggal = data.pertek_cpns_pns_l2th_tanggal;
          this.cpns.nomor_spmt = data.nomor_spmt;
          this.cpns.tmt_pns = data.tmt_pns;


          this.cpns.created_at = data.created_at;
          this.cpns.updated_at = data.updated_at;
          


          this.cpns.status = data.status;
          this.cpns.createdAt = data.createdAt;


          if (data.status != 1) {
            this.fileLoadSIA = false
            this.file_old = data.path[this.kodeDok].realname;
          }

          

    },

    // ====================================== INTEGRASI SI-ASN ====================================


    syncDataRiwayatSiASN: function(){

        this.loadRiwayatSIA = true;


        fetch(this.$store.state.url.URL_simpeg_cpns+'si_asn_viewOne', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              nip : this.nip,
              biodata_id : this.biodata_id,
              kode : this.kodeDok,
            })
        }).then((res) => res.json()).then((res_data) => {
          this.Notify('Sukses Sync Data', 'warning', 'check_circle_outline');


          this.getRiwayat();

          this.loadRiwayatSIA = false;
          // console.log(res_data);
        })
    },

    approveUsulanDataRiwayatSiASN : async function(){


      this.cpns.nip = this.nip
      this.cpns.kode = this.kodeDok
      this.cpns.file_old = this.file_old


      console.log(this.cpns);

      var sex = await UMUM.alertConfirm("Apakah anda ingin Approve Usulan?")

      if (sex.isConfirmed) {

        fetch(this.$store.state.url.URL_simpeg_cpns + "approve", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.cpns)
        }).then(res_data => {
            this.Notify('Sukses approve Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },

    kembalikan : async function(){
          
          
          this.cpns.nip = this.nip
          this.cpns.kode = this.kodeDok
          this.cpns.file_old = this.file_old


          console.log(this.cpns);

          var sex = await UMUM.alertConfirm("Apakah anda ingin Approve Usulan?")

          if (sex.isConfirmed) {


            fetch(this.$store.state.url.URL_simpeg_cpns + "approve", {
                method: "POST",
                headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.cpns)
            }).then(res_data => {
                this.Notify('Sukses approve Data', 'primary', 'check_circle_outline');
                this.getRiwayat();
            });


                  
          }
    },

    deleteDataRiwayatSiASN : async function(){


      this.cpns.nip = this.nip
      this.cpns.kode = this.kodeDok
      // console.log(this.cpns);

      var sex = await UMUM.alertConfirm("Apakah anda ingin menghapus riwayat?")


      if (sex.isConfirmed) {

        


        fetch(this.$store.state.url.URL_simpeg_cpns + "si_asn_delete", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(this.cpns)
        }).then(res_data => {
            this.Notify('Sukses menghapus Data', 'primary', 'check_circle_outline');
            this.getRiwayat();
        });


              
      }



    },


    getDownloadSIASN: async function(file,kode) {


      console.log("ppppppppp");
      console.log(file);
      console.log("ppppppppp");

              
      if (file.path == null || file.path == undefined) {
        this.fileLoadEmpty = true
        console.log("FILE KOSONG");
      } else {
        this.fileLoadEmpty = false


        console.log(file);
        
        var fileGet = file.path[kode].dok_uri
        this.fileLoadSIA = true
        fetch(this.$store.state.url.URL_simpeg_home + "lampiran_cpns", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                fileURL: fileGet,
                id : file.cpns_id,
                kode : this.kodeDok,
            })
            })
            .then(response => response.text())
            .then(res_data => {


                console.log("INI DIA");
                console.log(res_data)
                console.log("INI DIA");
                console.log(typeof(res_data));

                this.fileRiwayat = res_data
                this.fileLoadSIA = false

              

        });

      }


    },







    // ====================================== INTEGRASI SI-ASN ====================================



    alertku: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500
        });
    },
    Notify: function(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500
      });
    },

  },


  mounted () {
    this.getRiwayat();
    DATA_MASTER.getGolongan();
    DATA_MASTER.getLatStruktural();
    DATA_MASTER.getJnsKompetensi();
  },



};
